// extracted by mini-css-extract-plugin
export default {"SurpriseMessage":"SurpriseMessage-styles__SurpriseMessage__LO8ff"};